import { getJSON } from './ultile';
import {
  JUDGE_IS_LOGIN,
  UPDATE_LOGIN_STATUS,
  UPDATE_UID_TOKEN_LOGIN_STATUS,
  UPDATE_UID_LOGIN_STATUS
} from './login';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getFingerprint } from '@utiles/officialStore/index';

// 接口主域名
const MAIN_HOST = globalConfig.getMainHost();
export const JPSTORE_SHORT_HOST = `//jpstore.${MAIN_HOST}/`;
export const JPPASSPORT_SHORT_HOST = `//jppassport.${MAIN_HOST}/`;

// 接口路径
export const JPPASSPORT_UID_LOGIN = 'center/ajax/uid_login';
export const JPPASSPORT_TOKEN_LOGIN = 'web_login_code/login';
export const JPPASSPORT_TOKEN_LOGIN_BY_UID = 'web_login_code/uid_login';
export const JPPASSPORT_USER_JSON = 'center/ajax/get_store_user_json';
export const JPSTORE_INIT_DATA_NEW = 'index/init_data'; // 江美新版储值页初始化
export const JPSTORE_SERVER_LIST = 'ajax/server_list_history';
export const JPSTORE_USER_ROLE = 'ajax/get_user_role';
export const JPSTORE_PRICE_LIST = 'index/get_price_list_public';
export const JPSTORE_INIT_DATA = 'points/init_data'; // 江美代金币页初始化
export const JPSTORE_USER_INFO = 'points/getUserInfo';
export const JPSTORE_LOGOUT = 'center/ajax/logout';
export const JPSTORE_COUPON_LIST = 'coupon/get_coupon_list';
export const JPSTORE_PAY_COUPON_LIST = 'coupon/get_pay_coupon_list';
export const JPSTORE_SEND_VIP_COUPON = 'coupon/send_vip_coupon';
export const JPSTORE_FORM_DATA = 'form_data';
export const JPSTORE_CHILD_LIST = 'child_list';

//mutations动作
export const UPDATE_JP_CHILD_LIST = 'update_jp_child_list';
export const UPDATE_JP_CHILD_FORM = 'update_jp_child_form';

// actions动作
export const GET_JPSTORE_TOKEN_LOGIN_BY_UID = 'get_jpstore_token_login_by_uid';
export const GET_JPSTORE_CHILD_LIST = 'get_child_list';
export const GET_JPSTORE_CHILD_FORM = 'get_child_from';

// 日本平台保存在localStorage和cookie中的指纹的key
export const JPSTORE_UUID = 'jpstore_uuid';

export default {
  state: {
    jpChildList: [],
    jpChildForm: {}
  },
  mutations: {
    [UPDATE_JP_CHILD_LIST](state, childList) {
      state.jpChildList = childList;
    },
    [UPDATE_JP_CHILD_FORM](state, childForm) {
      state.jpChildForm = childForm;
    }
  },
  actions: {
    // 令牌登录-带uid的，用于消费代币时登录
    [GET_JPSTORE_TOKEN_LOGIN_BY_UID](
      { commit, dispatch },
      { uid, token, gameId }
    ) {
      return new Promise(async resolve => {
        const uuid = await getFingerprint(JPSTORE_UUID);
        const params = {
          uid,
          code: token,
          gameId: gameId,
          loginId: uuid,
          packageName: globalConfig.getHrefParam('packageName')
        };
        const callBack = async ({ res }) => {
          if (parseInt(res.result, 10) === 1) {
            commit(UPDATE_LOGIN_STATUS, true);
            commit(UPDATE_UID_TOKEN_LOGIN_STATUS, true);
            await dispatch(JUDGE_IS_LOGIN);
            commit(UPDATE_UID_LOGIN_STATUS, false);
            resolve({
              result: true,
              msg: 'succ'
            });
          } else {
            resolve({
              result: false,
              msg: res?.msg
            });
          }
        };
        getJSON(
          JPPASSPORT_SHORT_HOST + JPPASSPORT_TOKEN_LOGIN_BY_UID,
          params
        ).then(callBack);
      });
    },
    [GET_JPSTORE_CHILD_LIST]({ commit }, payload) {
      return new Promise((resolve) => {
        getJSON(JPSTORE_SHORT_HOST + payload.fType + '/' + JPSTORE_CHILD_LIST, {
          pay_type: payload.pay_type
        }).then(res => {
          let arr = [];
          if (res.res.result === '1') {
            arr = res.data;
          }
          commit(UPDATE_JP_CHILD_LIST, arr);
          resolve(arr);
        });
      });
    },
    [GET_JPSTORE_CHILD_FORM]({ commit }, payload) {
      return new Promise(resolve => {
        getJSON(JPSTORE_SHORT_HOST + payload.fType + '/' + JPSTORE_FORM_DATA, {
          pay_type: payload.pay_type,
          child_id: payload.child_id
        }).then(res => {
          let data = {};
          if (res.res.result === '1') {
            data = res.data;
          }
          commit(UPDATE_JP_CHILD_FORM, data);
          resolve(true);
        });
      });
    }
  }
};
